module.exports = {
	seo: {
		title: "Page not found",
		description: "",
		robots: "noindex nofollow",
	},
	overtitle: "404 - Page not found",
	title: "Oops! Something's wrong here",
	blurb: {
		p1: "The page you're looking for doesn't exist or may have been removed. You can",
		linkHomepage: "return to our homepage",
		p2: "or",
		linkContact: "contact us",
		p3: "to find what you're looking for.",
	},
};
